import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.css']
})
export class LoadingOverlayComponent implements OnInit {
  @Input() isLoading: boolean = false;
  @Input() message: string = 'Cargando datos';
  @Input() subMessage: string = 'Por favor espere un momento...';
  @Input() icon: string = 'fas fa-spinner';
  @Input() iconColor: string = 'text-success';
  @Input() height: string = '400px';
  @Input() zIndex: number = 10;
  @Input() overlayClass: string = 'loading-overlay';
  @Input() containerClass: string = 'text-center bg-white rounded shadow border p-4';
  @Input() showDots: boolean = true;
  @Input() dotsColor: string = 'bg-success';

  heightCategory: string = 'medium';

  ngOnInit() {
    this.determineHeightCategory();
  }

  ngOnChanges() {
    this.determineHeightCategory();
  }

  private determineHeightCategory() {
    const heightValue = parseInt(this.height.replace('px', ''));
    
    if (heightValue <= 300) {
      this.heightCategory = 'small';
    } else if (heightValue <= 500) {
      this.heightCategory = 'medium';
    } else {
      this.heightCategory = 'large';
    }
  }

  getOverlayClasses(): string {
    return `${this.overlayClass} position-absolute d-flex align-items-center justify-content-center`;
  }

  getOverlayAttributes(): any {
    return {
      'data-height-category': this.heightCategory
    };
  }
}
